export default __webpack_public_path__ + "static/media/get-line-img.10cf3c36.svg";